import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-5 d-flex" }
const _hoisted_2 = { class: "col-2 mx-3 my-auto padding-top-2px" }
const _hoisted_3 = { class: "mt-2 font-weight-bold text-grey-darken-3" }
const _hoisted_4 = { class: "col-10 ml-2 mt-4 font-weight-bold text-grey-darken-4" }

import { OUTPUT_TIME_LIST } from "@/services/consts/every_24_hours_report";
import { computed } from "vue";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectOutputTime',
  props: {
    modelValue: {},
    index: {},
    downloading: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.every24HoursReport.preview.outputTime')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_radio_group, {
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        disabled: props.downloading,
        inline: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OUTPUT_TIME_LIST), (outputTime, key) => {
            return (_openBlock(), _createBlock(_component_v_radio, {
              key: key,
              id: `output-time-${key}-${props.index}`,
              class: _normalizeClass(["ml-2 font-weight-bold", `output-time-${props.index}`]),
              label: outputTime.label,
              for: `${key}-${props.index}`,
              name: `output-time-${props.index}`,
              value: outputTime.value,
              color: "blue-darken-1",
              style: {"font-size":"18px"}
            }, null, 8, ["id", "class", "label", "for", "name", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ])
  ]))
}
}

})